import IaCartAPI from "ia-cart-api";

// Cart API Initialization
// Uses the ia-cart ID for Shopify section rendering of the cart if the project is using ia-cart.js.
// Also works for projects that are not using ia-cart.js.
document.addEventListener('DOMContentLoaded', () => {
  window.iaCartAPI = new IaCartAPI({ sectionId: document.querySelector('ia-cart')?.dataset.sectionId || null });
  if (window.iaCartAPI && document.querySelector('ia-cart')) {
    window.iaCartAPI.cart = JSON.parse(document.querySelector('ia-cart').querySelector("#ia-cart-json").textContent);
  }
});

// Theme global functions
// Hide extra sticky elements
// Show extra sticky elements
// Set scrollbar width
// Color scheme responsive handling
// Page events
window.iaTheme = {
  hideExtraStickyElements: () => {
    document.getElementById('freshworks-container')?.classList.add('ia-hidden');
  },
  showExtraStickyElements: () => {
    document.getElementById('freshworks-container')?.classList.remove('ia-hidden');
  },
  setScrollbarWidth: function() {
    const scrollDiv = document.createElement('div');
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.width = '100px';
    scrollDiv.style.height = '100px';
    scrollDiv.style.overflow = 'scroll';
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    document.documentElement.style.setProperty('--ia-scrollbar-width', `${scrollbarWidth}px`);
  }
}

window.iaTheme.pageEvents = [
  'DOMContentLoaded',
  'shopify:section:load',
  'shopify:section:select',
  'shopify:section:deselect',
  'shopify:section:reorder',
  'shopify:block:select',
  'shopify:block:deselect'
];

window.addEventListener('DOMContentLoaded', window.iaTheme.setScrollbarWidth);
window.addEventListener('resize', window.iaTheme.setScrollbarWidth);

// Color scheme responsive
window.iaTheme.colorSchemeResponsive = () => {
  const mq = window.matchMedia('(min-width: 1024px)');
  const elements = document.querySelectorAll('[data-color-scheme-mobile]');
  
  function swapClass(el) {
    const desktopScheme = el.dataset.colorSchemeDesktop;
    const mobileScheme = el.dataset.colorSchemeMobile;
    if (!desktopScheme || !mobileScheme) return;
    
    el.className = el.className.replace(/\bia-color-[^\s]+/g, '');
    el.style.opacity = 1;
    el.classList.add(mq.matches ? desktopScheme : mobileScheme);
  }
  
  function handleChange() {
    elements.forEach(swapClass);
  }
  
  mq.addEventListener('change', handleChange);
  elements.forEach(swapClass);
}
window.iaTheme.pageEvents.forEach(event =>
  document.addEventListener(event, () => {
    window.iaTheme.colorSchemeResponsive();
  })
);


